import {
    Component,
    forwardRef,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { IMapComponent } from "../../../map.models";
import { MapBaseSubComponent } from "../map-base-sub-component/map-base-sub.component";

@Component({
    selector: "rask-map-fullscreen",
    templateUrl: "./map-fullscreen.component.html",
    styleUrls: ["./map-fullscreen.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        { provide: MapBaseSubComponent,
            useExisting: forwardRef(() => MapFullscreenComponent) }
    ]
})
export class MapFullscreenComponent extends MapBaseSubComponent implements OnInit {
    widgetId = "map-fullscreen";
    isEnabled = true;
    @Input()
    set enabled(value: boolean) {
        this.isEnabled = value;
    }
    get enabled() {
        return this.isEnabled;
    }

    buttons = [
        {
            iconClass: "fa-expand-arrows",
            tooltipText: "Helskärm",
            visible: () => this.isReady(),
            disabled: this.disabled,
            widgetId: this.widgetId,
            click: () => this.click()
        }
    ];
    map: IMapComponent;

    constructor() {
        super();
    }

    isReady() {
        return true;
    }

    click() {
        this.map.toggleFullscreen();
    }

    ngOnInit(): void {
        this.mapReady.pipe(
            takeUntil(this.destroy$)
        ).subscribe(instance => {
            this.map = instance;
        });
    }

}
